import { FC, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import { copy } from "shared/assets";
import { CenterContent, MainContent } from "shared/styles";
import { IActionDropdownItem } from "shared/components";
import { useCompanyContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { useCompanyRoute } from "Bands/utils";
import { getUserCompanies } from "Bands/state";
import { FourOhFour } from "shared/pages";
import { CompanyInfo as CompanyInfoComponent } from "Bands/components";

const actionsCopy = copy.actions;

export const CompanyInfo: FC = () => {
  const dispatch = useDispatch();

  const { company } = useCompanyContext();
  const { pushRoute } = useCompanyRoute();

  useEffect(() => {
    if (!company) {
      dispatch(getUserCompanies());
    }
  }, [dispatch, company]);

  const cardActions: IActionDropdownItem[] = useMemo(() => {
    return [
      {
        label: actionsCopy.edit,
        handleClick: () => pushRoute(BAND_PATHS.EDIT_COMPANY_INFO),
      },
    ];
  }, [pushRoute]);

  if (!company) {
    return <FourOhFour />;
  }

  return (
    <CenterContent>
      <MainContent>
        <CompanyInfoComponent company={company} actions={cardActions} />
      </MainContent>
    </CenterContent>
  );
};
